import { Grid, Layout } from 'antd';

import { SPACE_MD } from '@/theme/buildAntdTheme';

import type React from 'react';

/** Matches filter sidebar width in FilteredListingFilterSidebar */
const FILTER_SIDEBAR_WIDTH = 260;

type FilteredListingBreakpointKey = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';

type FilteredListingResponsiveFilterLayoutProps = {
  inlineFilters: React.ReactNode;
  breakpoint?: FilteredListingBreakpointKey;
  /** Controlled by FilteredListingGrid, toggled from the header action. */
  collapsed: boolean;
  onCollapsedChange: (collapsed: boolean) => void;
  children: React.ReactNode;
};

export function FilteredListingResponsiveFilterLayout({
  inlineFilters,
  breakpoint = 'lg',
  collapsed,
  onCollapsedChange,
  children,
}: FilteredListingResponsiveFilterLayoutProps) {
  const screens = Grid.useBreakpoint();

  return (
    <Layout
      style={{
        gap: screens.lg && !collapsed ? SPACE_MD : 0,
      }}
    >
      <Layout.Sider
        breakpoint={breakpoint}
        collapsible
        collapsed={collapsed}
        collapsedWidth={0}
        width={FILTER_SIDEBAR_WIDTH}
        trigger={null}
        onCollapse={onCollapsedChange}
      >
        {inlineFilters}
      </Layout.Sider>
      <Layout.Content>{children}</Layout.Content>
    </Layout>
  );
}
